import { NavigationMetadata } from '../analytics';
import { COOKIE_CLIENT_ID, COOKIE_VISIT } from '../constants';
import { EventEmitterBase } from './event-emitter-base';
import { INavigationMetadata } from './event-sourcing';
import { Guid } from './guid';
import { PersistentStore } from './persistent-store';
import { TimeSpanUtils } from './time-span-utils';

export class NavigationMetadataProvider extends EventEmitterBase {

    private static __instance: NavigationMetadataProvider = null;

    private localKeyValueStore: PersistentStore = new PersistentStore();

    navigationMetadata: INavigationMetadata = null;

    init(): NavigationMetadata {
        if (this.navigationMetadata != null) {
            return {
                isNewVisit: false,
                isNewClient: false,
                isSpa: true,
            };
        }

        let isNewClient: boolean = false;
        let isNewVisit: boolean = false;

        let pageSessionId: string = Guid.v1();
        let clientId: string = this.localKeyValueStore.getItem(COOKIE_CLIENT_ID);
        let visitId: string = this.localKeyValueStore.getItem(COOKIE_VISIT);

        if (!clientId) { // new client
            isNewClient = true;
            clientId = Guid.v1();
            if (this.localKeyValueStore.cookieEnabled()) {
                this.localKeyValueStore.setItem(COOKIE_CLIENT_ID, clientId, TimeSpanUtils.FromDays(365));
            }
        }

        if (!visitId) { // new visit
            isNewVisit = true;
            visitId = Guid.v1();
            if (this.localKeyValueStore.cookieEnabled()) {
                this.localKeyValueStore.setItem(COOKIE_VISIT, visitId, TimeSpanUtils.FromMinutes(5));
            }
        }

        this.navigationMetadata = {
            cookieEnabled: this.localKeyValueStore.cookieEnabled(),
            pageSessionId: pageSessionId,
            browsingSessionId: visitId,
            clientId: clientId,
        };

        return {
            isNewVisit: isNewVisit,
            isNewClient: isNewClient,
        };
    }

    static GetInstance(): NavigationMetadataProvider {
        if (NavigationMetadataProvider.__instance === null) {
            NavigationMetadataProvider.__instance = new NavigationMetadataProvider();
        }
        return NavigationMetadataProvider.__instance;
    }

    static GetNavigationMetadata(): INavigationMetadata {
        NavigationMetadataProvider.GetInstance().init();
        return NavigationMetadataProvider.__instance.navigationMetadata;
    }
}
